import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { createEpicMiddleware } from 'redux-observable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../m... Remove this comment to see the full error message
import sentryMiddleware from '../middleware/sentryMiddleware';
import rootReducer from '../reducers';
import rootEpic from '../epics';
const epicMiddleware = createEpicMiddleware(rootEpic);
export default function configureStore(initialState, middleware) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const defaultMiddlewares = [epicMiddleware, NotificationMiddleware, thunk, sentryMiddleware()];
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware, ...defaultMiddlewares)));
}